import React from "react";
import "./InputComponent.scss"



const InputComponent = ({ label, value, onChange, placeholder, required, error, errorText, disable, type = "text" }) => {


    return (
        <div className="InputComponent-Virasat">
            <div className="input-label">
                {required && <span className="input-req">* </span>}
                {label}
            </div>
            <div className={`InputComponent-Virasat-container ${error ? "error" : disable ? "disable" : ""}`}>
                <input
                    className="InputComponent-Virasat-container-input"
                    value={value}
                    onChange={onChange}
                    type={type}
                    placeholder={placeholder}
                    disabled={disable ?? false}
                />
            </div>
            {
                errorText !== "" && < div className="input-error-text">
                    {errorText}
                </div>
            }
        </div >
    )
}
export default InputComponent
